export default function (...args)
{
	return {
		regex: /^\s*(\d{1,9})(\s+\d{1,9})*\s*$/,
		store_mask(match)
		{
			return match.trim().replaceAll('  ', ' ');
		},
		display_mask(match, ...args)
		{
			return match.trim().replaceAll('  ', ' ');
		}
	};
}

